import React from "react";
import Base from "./routes/Base";
import { QueryClient, QueryClientProvider } from "react-query";
import { BrowserRouter } from "react-router-dom";
import * as FullStory from "@fullstory/browser";

const queryClient = new QueryClient();

FullStory.init({
  orgId: "o-1HDFRE-na1",
  devMode: !window.location.origin.startsWith("https://geniecommerce.co"),
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
        <Base />
    </QueryClientProvider>
  );
}

export default App;
